import { useState } from 'react';
import { MdKitchen, MdExpandMore, MdExpandLess, MdRestaurant } from 'react-icons/md';
import { AiOutlineFilter, AiOutlineSearch } from 'react-icons/ai';

export const PrepReport = ({ data, filters }) => {
    const [show, setShow] = useState(true);
    const { totalItemsInProgress, uniqueGrades, uniqueOrderItems, totalQuantityForFilteredItem } = data;
    const { gradeFilter, setGradeFilter, itemFilter, setItemFilter } = filters;

    return (
        <div className="bg-white border-b-2 border-slate-200 shadow-md z-30">
            <div className="flex justify-between items-center p-5 cursor-pointer hover:bg-slate-50 transition-colors bg-gradient-to-r from-white to-slate-50" onClick={() => setShow(!show)}>
                <div className="flex items-center gap-3">
                    <div className="bg-custom_blue/10 p-2 rounded-full text-custom_blue"><MdKitchen size={24} /></div>
                    <div><h2 className="font-bold text-xl text-gray-800">Cozinha & Preparo</h2><p className="text-xs text-gray-500">Visão geral dos itens em produção</p></div>
                </div>
                <button className="text-gray-400">{show ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}</button>
            </div>

            {show && (
                <div className="px-6 pb-6 pt-2 animate-in slide-in-from-top-2 duration-300">
                    {totalItemsInProgress.length === 0 ? (
                        <div className="text-center py-4 bg-slate-50 rounded-xl border border-dashed border-slate-300">
                            <MdRestaurant className="mx-auto text-gray-300 mb-2" size={32} /><p className="text-sm text-gray-500 font-medium">Nenhum item na fila de preparo.</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-6">
                            {totalItemsInProgress.map(({ name, quantity }, idx) => (
                                <div key={idx} className="bg-white border-l-4 border-l-custom_blue border-y border-r border-slate-200 p-4 rounded-r-lg shadow-sm hover:shadow-md transition-all flex flex-col justify-between h-full">
                                    <span className="text-sm font-bold text-gray-700 leading-tight mb-2 line-clamp-2">{name}</span>
                                    <div className="flex justify-end"><span className="bg-custom_blue text-white font-black text-2xl px-3 py-1 rounded-lg shadow-sm min-w-[40px] text-center">{quantity}</span></div>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="pt-4 border-t border-slate-100 flex flex-wrap gap-4 items-end">
                        <div className="flex-1 min-w-[200px]">
                            <label className="text-xs font-bold text-gray-500 mb-1 block uppercase">Filtrar por Série</label>
                            <div className="relative group">
                                <AiOutlineFilter className="absolute left-3 top-3 text-gray-400" />
                                <select className="w-full pl-10 pr-3 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium outline-none hover:bg-white" value={gradeFilter} onChange={(e) => setGradeFilter(e.target.value)}>
                                    <option value="">Todas as séries</option>
                                    {uniqueGrades.map((g, idx) => <option key={idx} value={g}>{g}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="flex-1 min-w-[200px]">
                            <label className="text-xs font-bold text-gray-500 mb-1 block uppercase">Filtrar por Item</label>
                            <div className="relative group">
                                <AiOutlineSearch className="absolute left-3 top-3 text-gray-400" />
                                <select className="w-full pl-10 pr-3 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium outline-none hover:bg-white" value={itemFilter} onChange={(e) => setItemFilter(e.target.value)}>
                                    <option value="">Todos os itens</option>
                                    {uniqueOrderItems.map((item, idx) => <option key={idx} value={item.name}>{item.name}</option>)}
                                </select>
                            </div>
                        </div>
                        {itemFilter && (<div className="bg-yellow-50 text-yellow-800 px-4 py-2.5 rounded-lg text-sm font-bold border border-yellow-200 shadow-sm flex items-center gap-2"><span>Total:</span><span className="text-lg">{totalQuantityForFilteredItem}</span></div>)}
                    </div>
                </div>
            )}
        </div>
    );
};